
import React from "react";
import { Separator } from "@/components/ui/separator";
import InternalRecipientsGroup from "./form/InternalRecipientsGroup";

interface NotificationRecipientSelectProps {
  internalRecipients: {
    group1: boolean;
    group2: boolean;
  };
  onInternalCheckboxChange: (group: 'group1' | 'group2') => void;
}

const NotificationRecipientSelect = ({
  internalRecipients,
  onInternalCheckboxChange
}: NotificationRecipientSelectProps) => {
  return (
    <div className="space-y-4">
      <div>
        
        <div className="space-y-4">
          <InternalRecipientsGroup 
            internalRecipients={internalRecipients}
            onInternalCheckboxChange={onInternalCheckboxChange}
          />
          <Separator />
        </div>
      </div>
    </div>
  );
};

export default NotificationRecipientSelect;
